export const mfa = {
  // MFA Enrollment Page
  'mfa.enrollment.title': 'Enable Two-Factor Authentication',
  'mfa.enrollment.subtitle': 'Add an extra layer of security to your account',
  'mfa.enrollment.step': 'Step',
  'mfa.enrollment.of': 'of',
  'mfa.enrollment.complete': 'Complete',

  // Step 1: Introduction
  'mfa.enrollment.intro.title': 'Secure Your Account',
  'mfa.enrollment.intro.description': 'Two-factor authentication (MFA) helps protect your account from unauthorized access',
  'mfa.enrollment.intro.adminAlert.title': 'Admin Account Detected',
  'mfa.enrollment.intro.adminAlert.description': 'As an administrator, you must enable two-factor authentication to access protected resources.',
  'mfa.enrollment.intro.step1.title': 'Download an Authenticator App',
  'mfa.enrollment.intro.step1.description': 'Install Google Authenticator, Microsoft Authenticator, Authy, or 1Password',
  'mfa.enrollment.intro.step2.title': 'Scan QR Code',
  'mfa.enrollment.intro.step2.description': 'Use your app to scan the QR code we\'ll show you',
  'mfa.enrollment.intro.step3.title': 'Verify Setup',
  'mfa.enrollment.intro.step3.description': 'Enter the 6-digit code from your app to complete setup',
  'mfa.enrollment.intro.cancel': 'Cancel',
  'mfa.enrollment.intro.getStarted': 'Get Started',
  'mfa.enrollment.intro.starting': 'Starting...',

  // Step 2: QR Code
  'mfa.enrollment.verify.title': 'Verify Setup',
  'mfa.enrollment.verify.description': 'Enter the 6-digit code from your authenticator app',

  // Step 3: Success
  'mfa.enrollment.success.title': 'All Set!',
  'mfa.enrollment.success.description': 'Two-factor authentication is now enabled on your account',
  'mfa.enrollment.success.alert.title': 'Your Account is Now Protected',
  'mfa.enrollment.success.alert.description': 'You\'ll need to enter a code from your authenticator app each time you sign in. Make sure to keep your authenticator app accessible.',
  'mfa.enrollment.success.continue': 'Continue to Dashboard',

  // MFA Challenge Page
  'mfa.challenge.title': 'Two-Factor Authentication',
  'mfa.challenge.subtitle': 'Enter the verification code from your authenticator app',
  'mfa.challenge.adminAlert.title': 'Admin Verification Required',
  'mfa.challenge.adminAlert.description': 'As an administrator, you must verify your identity with two-factor authentication to access protected resources.',
  'mfa.challenge.factorTitle': 'Authenticator App',
  'mfa.challenge.factorDescription': 'Open your app and enter the 6-digit code',
  'mfa.challenge.help.title': 'Can\'t access your authenticator app?',
  'mfa.challenge.help.syncTime': 'Make sure your device\'s time is synced correctly',
  'mfa.challenge.help.correctApp': 'Check that you\'re using the correct authenticator app',
  'mfa.challenge.help.lostAccess': 'Contact support if you\'ve lost access to your authenticator',
  'mfa.challenge.help.codeRefresh': 'The code refreshes every 30 seconds. If you entered it incorrectly, wait for a new code.',
  'mfa.challenge.backToLogin': 'Back to Login',

  // MFA QR Code Component
  'mfa.qrcode.title': 'Scan QR Code',
  'mfa.qrcode.description': 'Open your authenticator app and scan this QR code',
  'mfa.qrcode.manualSetup': 'Manual Setup',
  'mfa.qrcode.manualDescription': 'If you can\'t scan the QR code, enter this code manually:',
  'mfa.qrcode.copySecret': 'Copy Secret',
  'mfa.qrcode.secretCopied': 'Secret copied!',
  'mfa.qrcode.recommendedApps': 'Recommended Apps',
  'mfa.qrcode.googleAuth': 'Google Authenticator',
  'mfa.qrcode.microsoftAuth': 'Microsoft Authenticator',
  'mfa.qrcode.authy': 'Authy',
  'mfa.qrcode.onePassword': '1Password',

  // MFA Code Input Component
  'mfa.codeInput.label': 'Verification Code',
  'mfa.codeInput.placeholder': 'Enter 6-digit code',
  'mfa.codeInput.verifying': 'Verifying...',
  'mfa.codeInput.verify': 'Verify',
  'mfa.codeInput.invalidCode': 'Invalid code. Please try again.',

  // MFA Factor List Component
  'mfa.factorList.title': 'Enrolled Authenticators',
  'mfa.factorList.noFactors': 'No authenticators enrolled',
  'mfa.factorList.addFactor': 'Add Authenticator',
  'mfa.factorList.status.active': 'Active',
  'mfa.factorList.status.verified': 'Verified',
  'mfa.factorList.enrolled': 'Enrolled',
  'mfa.factorList.remove': 'Remove',
  'mfa.factorList.confirmRemove.title': 'Remove Authenticator',
  'mfa.factorList.confirmRemove.description': 'Are you sure you want to remove this authenticator? You\'ll need to set up MFA again to access admin features.',
  'mfa.factorList.confirmRemove.cancel': 'Cancel',
  'mfa.factorList.confirmRemove.confirm': 'Remove',

  // Loading & Auth States
  'mfa.loading.checkingAuth': 'Checking authentication...',
  'mfa.loading.loadingFactors': 'Loading authenticators...',

  // Auth redirects
  'mfa.auth.loginRequired': 'Please login to enable two-factor authentication',
  'mfa.auth.loginToContinue': 'Please login to continue',
} as const;
